import { render } from "./GameOverModal.vue?vue&type=template&id=7e0fdb01"
import script from "./GameOverModal.vue?vue&type=script&lang=js"
export * from "./GameOverModal.vue?vue&type=script&lang=js"

import "./GameOverModal.vue?vue&type=style&index=0&id=7e0fdb01&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__